<div class="entete-section">
  <h2 class="primary-color">FORMATIONS</h2>
  <h3>{{ !!infoFormation ? infoFormation.libelle : '' }}</h3>
  <div>
    <a
      *ngFor="let dom of domHierarchy"
      [routerLink]="['/' + catalogConfigService.routingBaseUri + '/searchresult']"
      [queryParams]="{ domId: dom.id, domType: dom.type }"
    >
      <div *ngIf="dom.libelle">
        {{ dom.libelle }}
        <div class="k-icon k-i-arrow-chevron-right small-padding"></div>
      </div>
    </a>
  </div>
  <ng-container *ngIf="cartLink">
    <ags-add-to-cart [formation]="infoFormation" [modalite]="modalite"></ags-add-to-cart>
  </ng-container>
  <button
    kendoButton
    (click)="downloadDoc()"
    *ngIf="docPresent"
    [icon]="'download'"
    [primary]="true"
    class="small-margin colored-text"
  >
    FICHE FORMATION
  </button>
</div>
